import { Pipe, PipeTransform } from '@angular/core';
import { MatchPotentialItemPipe } from './match-potential-item.pipe';
import { IPDFMatching } from '../bulk-upload-pdf-files-step.component';

@Pipe({
  name: 'docTypeFromPdf',
  standalone: true
})
export class DocTypeFromPdfPipe extends MatchPotentialItemPipe implements PipeTransform {

  transform(file: File, PDFMatching: IPDFMatching[] ): number[] {
     return this.getItems(file?.name ?? '', 'document_type_ids', PDFMatching) as number[];
  }

}
